import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { sortBy } from "lodash";
import bind from "memoize-bind";

import { Accordion } from "lib/components/vendor";
import CSSModules from "lib/utils/css-modules";
import st from "lib/utils/index";
import { ProductDecorator } from "lib/decorators/index";
import { updateProduct } from "modules/products/utils";
import { open as openNewOrderModal } from "modules/orders/NewOrderModal";
import { pushCompanyRoute } from "modules/app/actions";
import ProductsListItem from "./ProductsListItem";
import styles from "./List.less";

@connect(null, (dispatch) =>
  bindActionCreators(
    {
      pushCompanyRoute,
      updateProduct,
      openNewOrderModal,
    },
    dispatch
  )
)
@CSSModules(styles)
export default class ProductsList extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      products: this.props.products,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.products !== nextProps.products) {
      this.setState({ products: nextProps.products });
    }
  }

  handleProductPropChange(product, prop, value) {
    this.props.updateProduct({
      id: product.id,
      [prop]: value,
    });

    this.setState({
      products: this.state.products.map((p) =>
        p.id === product.id
          ? new ProductDecorator({
              ...p,
              [prop]: value,
            })
          : p
      ),
    });
  }

  handleItemNewOrderClick(product) {
    const { openNewOrderModal } = this.props;
    let newOrder = {
      company: product.company,
      product,
      product_variant: product.product_variants.length === 1 ? product.product_variants[0] : undefined,
      agent: st.authorize.company.id === product.company.id ? null : st.authorize.company,
    };
    openNewOrderModal(newOrder);
  }

  renderProductsList(products) {
    const { pushCompanyRoute } = this.props;
    return (
      <div styleName="list">
        {products.map((product) => (
          <ProductsListItem
            key={product.id}
            product={product}
            pushCompanyRoute={pushCompanyRoute}
            onPropChange={bind(this.handleProductPropChange, this, product)}
            onNewOrderClick={bind(this.handleItemNewOrderClick, this, product)}
          />
        ))}
      </div>
    );
  }

  render() {
    const { products } = this.state;
    return this.renderProductsList(products);
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/ProductsList.jsx